import { ElementRef, Injectable, OnDestroy } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ResizeObserverService implements OnDestroy {
    private resizeObserver: ResizeObserver;

    public observe(element: ElementRef | HTMLElement, callbackFunc: () => void) {
        const nativeElement = element instanceof ElementRef ? element?.nativeElement : element;

        if (!nativeElement) {
            return;
        }

        if (this.resizeObserver) {
            this.resizeObserver.unobserve(nativeElement);
        }

        this.resizeObserver = new ResizeObserver(() => callbackFunc());
        this.resizeObserver.observe(nativeElement);
    }

    public unobserve(element: ElementRef | HTMLElement) {
        const nativeElement = element instanceof ElementRef ? element?.nativeElement : element;

        if (this.resizeObserver && nativeElement) {
            this.resizeObserver.unobserve(nativeElement);
        }
    }

    public ngOnDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }
}
